export default __webpack_public_path__ + "static/media/vcmessage.ecb90755.jpeg";